"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSvgIconRotations = void 0;
var react_1 = __importDefault(require("react"));
var build_svg_icon_1 = require("./build-svg-icon");
var transformMatrix = {
    Left: 0,
    Up: 1,
    Right: 2,
    Down: 3,
};
function getTransformStyle(starting, desired) {
    var startingValue = transformMatrix[starting];
    var desiredValue = transformMatrix[desired];
    var transformDeg = (desiredValue - startingValue) * 90;
    return transformDeg
        ? { transform: "rotate(".concat(transformDeg, "deg)"), transformOrigin: 'center' }
        : undefined;
}
function buildSvgIconRotations(content, contentOrientation, baseDisplayName, defaultSvgProps) {
    var _a = __read(Object.keys(transformMatrix).map(function (desiredOrientation) {
        var style = getTransformStyle(contentOrientation, desiredOrientation);
        return (0, build_svg_icon_1.buildSvgIcon)(react_1.default.cloneElement(content, { style: style }), "".concat(baseDisplayName).concat(desiredOrientation, "Icon"), defaultSvgProps);
    }), 4), Left = _a[0], Up = _a[1], Right = _a[2], Down = _a[3];
    return {
        Left: Left,
        Up: Up,
        Right: Right,
        Down: Down,
    };
}
exports.buildSvgIconRotations = buildSvgIconRotations;
exports.default = buildSvgIconRotations;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnVpbGQtc3ZnLWljb24tcm90YXRpb25zLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vaWNvbnMvYnVpbGQtc3ZnLWljb24tcm90YXRpb25zLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsZ0RBQTBCO0FBQzFCLG1EQUFnRDtBQUloRCxJQUFNLGVBQWUsR0FBRztJQUN0QixJQUFJLEVBQUUsQ0FBQztJQUNQLEVBQUUsRUFBRSxDQUFDO0lBQ0wsS0FBSyxFQUFFLENBQUM7SUFDUixJQUFJLEVBQUUsQ0FBQztDQUNSLENBQUM7QUFFRixTQUFTLGlCQUFpQixDQUFDLFFBQXFCLEVBQUUsT0FBb0I7SUFDcEUsSUFBTSxhQUFhLEdBQUcsZUFBZSxDQUFDLFFBQVEsQ0FBQyxDQUFDO0lBQ2hELElBQU0sWUFBWSxHQUFHLGVBQWUsQ0FBQyxPQUFPLENBQUMsQ0FBQztJQUU5QyxJQUFNLFlBQVksR0FBRyxDQUFDLFlBQVksR0FBRyxhQUFhLENBQUMsR0FBRyxFQUFFLENBQUM7SUFFekQsT0FBTyxZQUFZO1FBQ2pCLENBQUMsQ0FBQyxFQUFFLFNBQVMsRUFBRSxpQkFBVSxZQUFZLFNBQU0sRUFBRSxlQUFlLEVBQUUsUUFBUSxFQUFFO1FBQ3hFLENBQUMsQ0FBQyxTQUFTLENBQUM7QUFDaEIsQ0FBQztBQVNELFNBQWdCLHFCQUFxQixDQUNuQyxPQUFvQixFQUNwQixrQkFBK0IsRUFDL0IsZUFBdUIsRUFDdkIsZUFBK0M7SUFFekMsSUFBQSxLQUFBLE9BQTBCLE1BQU0sQ0FBQyxJQUFJLENBQUMsZUFBZSxDQUFDLENBQUMsR0FBRyxDQUM5RCxVQUFDLGtCQUFrQjtRQUNqQixJQUFNLEtBQUssR0FBRyxpQkFBaUIsQ0FDN0Isa0JBQWtCLEVBQ2xCLGtCQUFpQyxDQUNsQyxDQUFDO1FBQ0YsT0FBTyxJQUFBLDZCQUFZLEVBQ2pCLGVBQUssQ0FBQyxZQUFZLENBQUMsT0FBTyxFQUFFLEVBQUUsS0FBSyxPQUFBLEVBQUUsQ0FBQyxFQUN0QyxVQUFHLGVBQWUsU0FBRyxrQkFBa0IsU0FBTSxFQUM3QyxlQUFlLENBQ2hCLENBQUM7SUFDSixDQUFDLENBQ0YsSUFBQSxFQVpNLElBQUksUUFBQSxFQUFFLEVBQUUsUUFBQSxFQUFFLEtBQUssUUFBQSxFQUFFLElBQUksUUFZM0IsQ0FBQztJQUVGLE9BQU87UUFDTCxJQUFJLE1BQUE7UUFDSixFQUFFLElBQUE7UUFDRixLQUFLLE9BQUE7UUFDTCxJQUFJLE1BQUE7S0FDTCxDQUFDO0FBQ0osQ0FBQztBQTFCRCxzREEwQkM7QUFFRCxrQkFBZSxxQkFBcUIsQ0FBQyJ9


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/icons/icons/build-svg-icon-rotations.js
// module id = 952
// module chunks = 25